export default __webpack_public_path__ + "static/media/step6.28873295.png";